// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_bfa41c7","widgetRow":"_cc2e09e","widgetHeaderRow":"_017744b"};